import { Box, Card, CardContent, Link, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { acknowledgements } from './acknowledgements';

const AcknowledgmentSection = () => (
  <Box
    sx={{
      display: 'grid',
      gap: 3,
      gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, minmax(0, 1fr))',
        md: 'repeat(3, minmax(0, 1fr))',
      },
    }}
  >
    {acknowledgements.map((acknowledgement) => (
      <Card key={acknowledgement.name} sx={{ height: '100%' }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.25, height: '100%' }}>
          <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 700 }}>
            {acknowledgement.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <Trans i18nKey="acknowledgment.license-value" values={{ license: acknowledgement.license }}>
              License: {{ license: acknowledgement.license }}
            </Trans>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <Trans i18nKey="acknowledgment.publisher-value" values={{ publisher: acknowledgement.publisher }}>
              Publisher: {{ publisher: acknowledgement.publisher }}
            </Trans>
          </Typography>
          {acknowledgement.copyright && (
            <Typography variant="body2" color="text.secondary">
              {acknowledgement.copyright}
            </Typography>
          )}
          <Link
            href={acknowledgement.repository}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ mt: 'auto', display: 'inline-flex', alignItems: 'center', fontWeight: 600 }}
          >
            <Trans i18nKey="acknowledgment.view-repository">View repository</Trans>
          </Link>
        </CardContent>
      </Card>
    ))}
  </Box>
);

export default AcknowledgmentSection;
